import { ReportType } from '@/shared/api/protocol-ts/model/dto_report_pb';
import { REPORT_GENERATION_AVERAGE_TIME } from '@/shared/config';

export const getRelativeProgress = (
  reportType: ReportType,
  createdAt?: Date,
): number => {
  if (!createdAt) {
    return 0;
  }

  const reportCreatedDiffMs =
    new Date().getTime() - new Date(createdAt).getTime();

  const reportAverageCreationTime =
    REPORT_GENERATION_AVERAGE_TIME[reportType] ||
    REPORT_GENERATION_AVERAGE_TIME[ReportType.ReportType_CBCT_GP];

  const relativeProgress = Math.floor(
    (reportCreatedDiffMs / reportAverageCreationTime) * 100,
  );

  return relativeProgress;
};
